var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolsFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#0044c6"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C4.20435 0 3.44129 0.316071 2.87868 0.87868C2.31607 1.44129 2 2.20435 2 3C2 3.79565 2.31607 4.55871 2.87868 5.12132C3.44129 5.68393 4.20435 6 5 6C5.79565 6 6.55871 5.68393 7.12132 5.12132C7.68393 4.55871 8 3.79565 8 3C8 2.20435 7.68393 1.44129 7.12132 0.87868C6.55871 0.316071 5.79565 0 5 0ZM13 0C12.2043 0 11.4413 0.316071 10.8787 0.87868C10.3161 1.44129 10 2.20435 10 3C10 3.79565 10.3161 4.55871 10.8787 5.12132C11.4413 5.68393 12.2043 6 13 6C13.7956 6 14.5587 5.68393 15.1213 5.12132C15.6839 4.55871 16 3.79565 16 3C16 2.20435 15.6839 1.44129 15.1213 0.87868C14.5587 0.316071 13.7956 0 13 0ZM17.334 4.00781C17.148 3.99581 16.9958 4.14798 17.0078 4.33398C17.0368 4.80398 17.174 5.67005 17.752 6.24805C18.33 6.82505 19.196 6.96319 19.666 6.99219C19.852 7.00419 20.0042 6.85202 19.9922 6.66602C19.9632 6.19602 19.826 5.32995 19.248 4.75195C18.67 4.17395 17.804 4.03681 17.334 4.00781ZM4 8C1.791 8 0 9.791 0 12V17C0 17.552 0.448 18 1 18H6C6 16.895 6.895 16 8 16H10C11.105 16 12 16.895 12 18H17C17.552 18 18 17.552 18 17V12C18 9.791 16.209 8 14 8H4ZM9 10C10.105 10 11 10.895 11 12C11 13.105 10.105 14 9 14C7.895 14 7 13.105 7 12C7 10.895 7.895 10 9 10Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsFamily);
export default __webpack_public_path__ + "static/media/ToolsFamily.e6162073d1d397834c093ff240262353.svg";
export { ForwardRef as ReactComponent };